import firebase from "firebase/compat/app"
import "firebase/compat/auth"

const firebaseConfig = {
    apiKey: "AIzaSyClsLxB0wQdLK4DAn6u66HUoE5cYsKdm7Y",
    authDomain: "tube-link-firebase.firebaseapp.com",
    projectId: "tube-link-firebase",
    storageBucket: "tube-link-firebase.appspot.com",
    messagingSenderId: "412444052159",
    appId: "1:412444052159:web:669b99a2bdeed71fbb540a",
    measurementId: "G-MFGDER67PD"
};
// eslint-disable-next-line
const app = firebase.initializeApp(firebaseConfig)
const auth = firebase.auth()
const provider = new firebase.auth.GoogleAuthProvider()

export { auth, provider }